// NOTE: when `maxRows` is 1, this component is buggy in FireFox and always shows "Show More".

import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './expandable_paragraph.less'
import Separator from 'components/common/separator'
import { getI18n } from 'client/i18n'

const TEXT_LINE_HEIGHT = 1.6
const LIGHT_TEXT_LINE_HEIGHT = 1.5
const TEXT_FONT_SIZE = 15
const LIGHT_TEXT_FONT_SIZE = 13
const i18n = getI18n('components/expandable_paragraph')

class ExpandableParagraph extends React.Component {
  static propTypes = {
    titleText: PropTypes.string,
    children: PropTypes.node,
    maxRows: PropTypes.number,
    lightText: PropTypes.bool,
    lightLink: PropTypes.bool,
  }

  static defaultProps = { maxRows: 3 }
  state = { open: false }

  updateHeight = () => {
    this.setState({ height: this.detailsText.scrollHeight })
  }

  componentDidMount() {
    this.updateHeight()
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.updateHeight()
  }

  onShowMore = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    // these are hard-coded and not derived from the CSS since the manual height set after mounting is counting on `scrollHeight`
    // which will only be set if this is hard-coded here.
    const lineHeight = this.props.lightText
      ? LIGHT_TEXT_LINE_HEIGHT
      : TEXT_LINE_HEIGHT // in em
    const fontSize = this.props.lightText
      ? LIGHT_TEXT_FONT_SIZE
      : TEXT_FONT_SIZE // in px

    let detailsClass = ''
    let buttonText = ''
    let detailsStyle = {}
    let detailsTextStyle = { lineHeight, fontSize }
    let showMoreButton = false
    if (this.state.height) {
      if (this.state.height > this.props.maxRows * lineHeight * fontSize) {
        showMoreButton = true
        // overflow
        detailsClass = this.state.open ? 'details-open' : 'details'
        buttonText = this.state.open ? i18n('show_less') : i18n('show_more')

        detailsStyle = this.state.open
          ? { height: this.state.height + 'px' }
          : { height: `${this.props.maxRows * lineHeight * fontSize}px` }

        detailsTextStyle = Object.assign(
          this.state.open ? {} : { WebkitLineClamp: this.props.maxRows },
          detailsTextStyle
        )
      } else {
        // no overflow
        detailsClass = 'details-open'
      }
    }

    return (
      <div>
        {this.props.titleText && (
          <span>
            <div styleName="title">{this.props.titleText}</div>
            <Separator type="dotted" />
          </span>
        )}
        <div styleName={detailsClass} style={detailsStyle}>
          <div
            styleName={
              this.props.lightText ? 'details-text-light' : 'details-text'
            }
            ref={detailsText => {
              this.detailsText = detailsText
            }}
            style={detailsTextStyle}
          >
            {this.props.children}
          </div>
        </div>
        {showMoreButton && (
          <a
            data-pa-click="showMoreText"
            href="javascript:;"
            styleName={this.props.lightLink ? 'more-link-light' : 'more-link'}
            onClick={this.onShowMore}
          >
            {buttonText}
          </a>
        )}
      </div>
    )
  }
}

export default cssModules(ExpandableParagraph, styles, { allowMultiple: true })
